import React from "react";
import Mydata from "@/app/data/blog/chicago-Ohare.json";
function tableData() {
  const Data = Mydata[2];
  return (
    <div className="mx-auto max-w-5xl px-4 text-[#2B3252] text-lg">
      {Data.ParkingOptions.map((option, index) => (
        <div key={index} className="mb-8">
          {/* Main Title */}
          <h2 id={option.id} className="blogtitle">{option.title}</h2>
          <p className="blogcontent">{option.description}</p>

          {option.sections.map((section, secIndex) => (
            <div key={secIndex} className="mb-6">
              <h3 className="blogSubtitle">{section.heading}</h3>

              {section.image && (
                <img
                  src={section.image}
                  alt={section.heading}
                  className="mb-4 rounded-[20px]"
                />
              )}
              {section?.content && (
                <p
                  className="blogcontent"
                  dangerouslySetInnerHTML={{ __html: section.content }}
                ></p>
              )}
              {section?.content2 && (
                <p
                  className="blogcontent"
                  dangerouslySetInnerHTML={{ __html: section.content2 }}
                ></p>
              )}
              {section.subsections && (
                <div className="flex flex-wrap">
                  <div className="flex flex-wrap gap-12">
                    {section.subsections.map((subsection, subIndex) => (
                      <div
                        key={subIndex}
                        className="w-full md:w-1/2 flex-1 mb-6 "
                      >
                        {/* Title and Description */}
                        <h4 className="blogh4 mb-2">{subsection.title}</h4>
                        <p className="blogcontent mb-4">
                          {subsection.description}
                        </p>

                        {/* Rates Table */}
                        <table className="table-auto  w-full border-collapse ">
                          <thead>
                            <tr>
                              <th className="border  cardbg border-gray-300 px-2 py-1 text-left">
                                Time Ranges
                              </th>
                              <th className="border cardbg  px-2 py-1 text-left">
                                Rates
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {subsection.rates.map((rate, rateIndex) => {
                              const [hours, price] = rate.split(": "); // Split hours and price
                              return (
                                <tr key={rateIndex}>
                                  <td className="border border-gray-300 rounded-lg px-2 py-1">
                                    {hours}
                                  </td>
                                  <td className="border border-gray-300 px-2 py-1">
                                    {price}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    ))}
                  </div>
                </div>
              )}




              {/* {section.rates_table && (
                <table className="w-full border border-gray-300 mt-4 mb-4">
                  <thead>
                    <tr>
                      {section.rates_table[0].map((header, headerIndex) => (
                        <th
                          key={headerIndex}
                          className="border border-gray-300 px-2 py-1 text-left cardbg"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {section.rates_table.slice(1).map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <td
                            key={cellIndex}
                            className="border border-gray-300 px-2 py-1"
                          >
                            {cell}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )} */}

              {section.rates && (
                <ul className="list-disc pl-6 mb-4">
                  {section.rates.map((rate, rateIndex) => (
                    <li key={rateIndex}>{rate}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      ))}
       <table

      border="1"
      style={{
        border:"1px solid rgb(222 226 230)",
        borderCollapse: 'collapse',
        width: '100%',
        textAlign: 'center',
      }}
    >
     <thead>
  <tr
    style={{
      backgroundColor: '#f4ecd8',
      border: '1px solid rgb(222, 226, 230)',
      marginBottom: '10px',
    }}
  >
    <th
      style={{
        border: '1px solid rgb(222, 226, 230)',
        padding: '5px 10px', // Add spacing inside the cells
      }}
    >
      Economy Lots
    </th>
    <th
      style={{
        border: '1px solid rgb(222, 226, 230)',
        padding: '5px 10px', // Add spacing inside the cells
      }}
    >
      Time Ranges
    </th>
    <th
      style={{
        border: '1px solid rgb(222, 226, 230)',
        padding: '5px 10px', // Add spacing inside the cells
      }}
    >
      Rates
    </th>
  </tr>
</thead>

      <tbody style={{border:"1px solid rgb(222 226 230)"}} >
        <tr style={{border:"1px solid rgb(222 226 230)"}}>
          <th style={{border:"1px solid rgb(222 226 230)",fontWeight:"bold"}} rowSpan="5">F</th>
          <td style={{border:"1px solid rgb(222 226 230)"}}>0 – 1 hour</td>
          <td style={{border:"1px solid rgb(222 226 230)"}}>$3.00</td>
        </tr>
        <tr>
          <td style={{border:"1px solid rgb(222 226 230)"}}>1 – 2 hours</td>
          <td style={{border:"1px solid rgb(222 226 230)"}}>$6.00</td>
        </tr>
        <tr>
          <td style={{border:"1px solid rgb(222 226 230)"}}>2 – 3 hours</td>
          <td style={{border:"1px solid rgb(222 226 230)"}}>$10.00</td>
        </tr>
        <tr>
          <td style={{border:"1px solid rgb(222 226 230)"}}>3 – 4 hours</td>
          <td style={{border:"1px solid rgb(222 226 230)"}}>$14.00</td>
        </tr>
        <tr>
          <td style={{border:"1px solid rgb(222 226 230)"}}>4 – 24 hours</td>
          <td style={{border:"1px solid rgb(222 226 230)"}}>$22.00</td>
        </tr>
        <tr>
          <td style={{border:"1px solid rgb(222 226 230)",fontWeight:"bold"}} rowSpan="2" >G & H</td>
          <td style={{border:"1px solid rgb(222 226 230)"}}>0 – 1 hour</td>
          <td style={{border:"1px solid rgb(222 226 230)"}}>$3.00</td>
        </tr>
        <tr>
          <td style={{border:"1px solid rgb(222 226 230)"}}>1 – 24 hours</td>
          <td style={{border:"1px solid rgb(222 226 230)"}}>$15.00</td>
        </tr>
      </tbody>
    </table>



    <h3 className="blogSubtitle mt-9">
    Valet Parking & Premium Parking
    </h3>
    <p className="blogcontent">For people who are in a rush and don’t have the time to go around and look for a parking spot, valet parking has got you covered. You will find this at any terminal from 1 to 3 and the charges for this service are $60. </p>
    <p className="blogcontent">As for premium parking, the rate for this service is the same as valet parking, which is $60. When you choose premium parking, you get access to Terminals 1 and 3, and the spots are taken on a first-come, first-serve basis.</p>

    </div>
  );
}

export default tableData;
